<ol class="breadcrumb">
  <li class="breadcrumb-item active" aria-current="page">
    <span>Configurações</span>
  </li>
</ol>

@if (loginService.token$ | async; as usuario) {
  <mat-card>
    <mat-card-title>
      <mat-icon class="align-middle">person</mat-icon>
      <span class="align-middle px-2">{{usuario.usuario}}</span>
    </mat-card-title>
    <mat-card-subtitle>
      <mat-icon class="align-middle">email</mat-icon>
      <span class="align-middle px-2">{{usuario.email}}</span>
    </mat-card-subtitle>
    <mat-card-content class="w-100 p-2">
      <lib-tema-configuracao-card></lib-tema-configuracao-card>
    </mat-card-content>
  </mat-card>
}
